import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Tab, Nav, Tabs, Button, Form } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import {
  GetInitials,
  SliderPanel,
  ManageMapperMenu,
  LoaderWrapper,
} from "../../../components";
import { withAppLayout } from "../../../hoc";
import {
  manageMapperFormNames,
  MANAGE_MAPPER_MENU,
  MANAGE_MAPPER_MENU_WITH_OVERVIEW,
  FLOW_TYPES,
  getPathWithParam,
  ROUTES,
  manageCensusFormNames,
  formFields,
  ssnMasking,
} from "../../../utils";
import { ManageDistributionRoutes } from "../../../routes";
import {
  manageMapperStore,
  ManageMapperProvider,
  setManageMapperSelectedMenu,
  ManageDistributionProvider,
  manageDistributionStore,
  setCensusDataFromAPI,
} from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import { getEmployeeCensusInformation } from "../../../services";
import { faTimes, faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import WithdrawalRequestPersonalInformationFields from "../../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestPersonalInformation";
import WithdrawalRequestContactInformationFields from "../../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestContactInformtion";
import WithdrawalRequestEmploymentAgeDetail from "../../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestEmployeeAgeDetails";
import WithdrawalRequestEmployeeClassification from "../../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestEmployeeClassification";
import WithdrawalRequestOtherInformation from "../../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestOtherInformation";
//import "../../../styles/containers/";
export const Distribution = (props) => {
  const formName = manageCensusFormNames.PERSONAL_INFORMATION;
  const fields = formFields[formName];
  const { state, dispatch } = useContext(manageDistributionStore);
  //const isFixedLength = get(state, "api.fileuploadData.mappingConfiguration.format", 3)?get(state, "api.fileuploadData.mappingConfiguration.format", 3):get(state, "api.data.format", 3) === 2;
  const isFetching = get(state, "api.isFetching", {});

  //const flow = get(state, "flow");
  const [moreInfoSlideOpen, setMoreInfoSlideOpen] = useState(false);
  const [saveTriggered, setSaveTriggered] = useState(false);
  const [keyValue, setKeyValue] = useState(1);
  const [newCmpyId, setNewCmpyId] = useState({ prevId: null, newId: null });
  const [isCmpy, setIsCmpy] = useState(censusId);
  const data = get(state, "api.data", {});
  const { flow } = useRouterParams();
  const censusId = get(state, "censusId");
  const [filteredValues, setFilteredValues] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  useDeepEffect(() => {
    if (censusId) {
      setDataLoading(true);
      getEmployeeCensusInformation(censusId)
        .then((response) => {
          setFilteredValues(response);
          dispatch(setCensusDataFromAPI(response));
          setDataLoading(false);
        })
        .catch((error) => setDataLoading(false));
    }
  }, [censusId]);

  const setCompanyId = (id) => {
    if (newCmpyId.prevId == null) setNewCmpyId({ prevId: id, newId: id });
    else setNewCmpyId({ prevId: newCmpyId.newId, newId: id });
  };

  const changeInCmpyId = (id) => {
    if (id != newCmpyId.prevId && newCmpyId.prevId != null) return true;
    else return false;
  };
  const [isStartDate, setIsStartDate] = useState(false);
  const [isEndDate, setIsEndDate] = useState(false);
  const [tabColors, setTabColors] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
  });
  const initialValues = {
    country: "USA",
    countryId: 1,
    foreignCountry: null,
    foreignState: null,
    additionalCountry: "USA",
    additionalCountryId: 1,
    additionalForeignCountry: null,
    additionalForeignState: null,
    familyMemberOfOwnerIndicator: false,
    pendingQDROIndicator: false,
    returnMailIndicator: false,
    officerIndicator: false,
    hceIndicator: false,
    keyEmployeeIndicator: false,
    insiderOrRestrictedEmployeeIndicator: false,
  };
  const setTabColor = (tabValue) => {
    return keyValue == tabValue
      ? "#2f80ed"
      : saveTriggered
      ? tabColors[tabValue]
        ? "red"
        : "green"
      : "#bdbdbd";
  };

  const setTabClass = (tabValue) => {
    return keyValue == tabValue
      ? "active"
      : saveTriggered
      ? tabColors[tabValue]
        ? "error"
        : "green"
      : "";
  };

  const setTabIcon = (tabValue) => {
    return tabColors[tabValue] == true ? faExclamationCircle : faCheckCircle;
  };

  const tabChange = (key) => {
    setKeyValue(key);
  };

  const tabPersonel = () => {
    setKeyValue(1);
  };

  const tabContact = () => {
    setKeyValue(2);
  };

  const tabDates = () => {
    setKeyValue(3);
  };
  const tabEmployee = () => {
    setKeyValue(4);
  };
  const tabOthers = () => {
    setKeyValue(5);
  };

  //   useEffect(() => {
  //     dispatch(setManageMapperSelectedMenu(location.pathname));
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, [location]);

  const mapperName = get(
    state,
    `${manageMapperFormNames.MAP_AND_TRANSFORM}.mapperName`,
    ""
  );

  const isLoading = flow === FLOW_TYPES.ADD ? false : isFetching;
  const isEdit = flow === FLOW_TYPES.EDIT;
  const employeeImage = filteredValues.imageURL;
  return (
    <LoaderWrapper isLoading={dataLoading}>
      <div className="row manage-company-wrapper">
        <Col className="h-100">
          <Row sm="12" className="h-100">
            {false && (
              <Col className="manage-company-column manage-menu-items">
                <div
                  className="d-flex flex-column transaction-employee-details"
                  style={{ textAlign: "center" }}
                >
                  <div className="d-flex justify-content-center">
                    {!isEmpty(employeeImage) ? (
                      <div>
                        <img
                          alt=""
                          src={employeeImage}
                          style={{
                            width: "78px",
                            height: "78px",
                            borderRadius: "50%",
                          }}
                          className="img-fluid"
                        />
                      </div>
                    ) : (
                      <div>
                        <div style={{ marginTop: "50%" }}>
                          <GetInitials name={filteredValues.firstName} />
                        </div>
                      </div>

                      // <div>
                      //   <div style={{ marginLeft: "35%" }}>
                      //     <GetInitials name={filteredValues.firstName} />
                      //   </div>
                      //   <div style={{ marginLeft: "55%" }}>
                      //     <Link onClick={() => setisPopupOpen(true)}>
                      //       {/* <GetInitials name={companyName} /> */}
                      //       <FontAwesomeIcon icon={faPencilAlt} size="1x" />
                      //     </Link>
                      //   </div>
                      // </div>
                    )}
                  </div>
                  <div className="trans-employee-name mt-2">
                    {filteredValues.firstName} {filteredValues.middleName}{" "}
                    {filteredValues.lastName}
                  </div>
                  <div className="employee-id mt-1">
                    {ssnMasking(filteredValues.uniquePersonalIdentification)}
                  </div>
                  {filteredValues.employmentStatus == "Active" ? (
                    <div className="employee-status mt-1">
                      <FontAwesomeIcon
                        icon={faCheckCircle}
                        color=" #1C7E18"
                        size="md"
                      />{" "}
                      {filteredValues.employmentStatus}
                    </div>
                  ) : filteredValues.employmentStatus == "Terminated" ? (
                    <div className="employee-status-danger mt-1">
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        color="#DE2323"
                        size="md"
                      />{" "}
                      {filteredValues.employmentStatus}
                    </div>
                  ) : (
                    filteredValues.employmentStatus
                  )}
                  <div className="company-name mt-1">
                    {filteredValues.companyName}
                  </div>
                  <div
                    className="more-info mt-1"
                    onClick={() => setMoreInfoSlideOpen(true)}
                  >
                    more info
                  </div>
                </div>
              </Col>
            )}
            <Col className="h-100 manage-menu-content w-50">
              <ManageDistributionRoutes mapperName={mapperName} />
            </Col>
          </Row>
        </Col>
        <SliderPanel
          isOpen={moreInfoSlideOpen}
          size="80"
          showCancel={false}
          backdropClicked={() => setMoreInfoSlideOpen(false)}
        >
          {" "}
          <div>
            <div className="disp-flex-row justify-content-space-between dark-grey-color fw-500 ft-16 Border-Bottom census-tabs-head">
              <p className="plan-sub-heading">Employee Information</p>
              <FontAwesomeIcon
                icon={faTimes}
                style={{ cursor: "pointer" }}
                onClick={() => setMoreInfoSlideOpen(false)}
              />
            </div>
            <Tabs
              style={{ border: "none", marginTop: "20px" }}
              activeKey={keyValue}
              transition={false}
              onSelect={tabChange}
              mountOnEnter
              unmountOnExit
            >
              <Tab
                eventKey={1}
                title={
                  <div>
                    <FontAwesomeIcon
                      icon={setTabIcon(1)}
                      color={setTabColor(1)}
                    />
                    &nbsp;
                    <span class="tabName">
                      Personal <span className="pl-20">Details</span>
                    </span>
                  </div>
                }
                tabClassName={setTabClass(1)}
              >
                <WithdrawalRequestPersonalInformationFields
                  fields={fields}
                  filteredValues={filteredValues}
                  // // isEdit={isEdit}
                  // // isSave={isSave}
                  // setCompanyId={setCompanyId}
                  // isCmpy={isCmpy}
                />
                {/* {isEdit == true ? null : (
                <Button onClick={tabContact}>Next</Button>
              )} */}
              </Tab>
              <Tab
                style={{ border: "none" }}
                eventKey={2}
                title={
                  <div>
                    <FontAwesomeIcon
                      icon={setTabIcon(2)}
                      color={setTabColor(2)}
                    />
                    &nbsp;
                    <span class="tabName">
                      Contact Information &{" "}
                      <span className="pl-20">Bank Account Details</span>
                    </span>
                  </div>
                }
                tabClassName={setTabClass(2)}
                disabled={false}
              >
                <WithdrawalRequestContactInformationFields
                  fields={fields}
                  filteredValues={filteredValues}
                  // isEdit={isEdit}
                  // isSave={isSave}
                  // setAdditionalAddress={(val) => {
                  //   setAdditionalAddress(val);
                  // }}
                  // additionalAddress={additionalAddress}
                />
                {/* {isEdit == true ? null : (
                <>
                  {" "}
                  <Button
                    className="add-btn mr-4"
                    onClick={tabPersonel}
                  >
                    Previous
                  </Button>
                  <Button onClick={tabDates}>Next</Button>
                </>
              )} */}
              </Tab>
              <Tab
                eventKey={3}
                title={
                  <div>
                    <FontAwesomeIcon
                      icon={setTabIcon(3)}
                      color={setTabColor(3)}
                    />
                    &nbsp;
                    <span class="tabName">
                      Employment <br />
                      <span className="pl-20">& Age Details</span>
                    </span>
                  </div>
                }
                tabClassName={setTabClass(3)}
                disabled={false}
              >
                <WithdrawalRequestEmploymentAgeDetail
                  // {...formProps}
                  fields={fields}
                  filteredValues={filteredValues}
                  // isEdit={isEdit}
                  // isSave={isSave}
                  // isStartDate={isStartDate}
                  // isEndDate={isEndDate}
                />
                {/* {isEdit == true ? null : (
                <>
                  {" "}
                  <Button
                    className="add-btn mr-4"
                    onClick={tabContact}
                  >
                    Previous
                  </Button>
                  <Button onClick={tabEmployee}>Next</Button>
                </>
              )} */}
              </Tab>
              <Tab
                eventKey={4}
                title={
                  <div>
                    <FontAwesomeIcon
                      icon={setTabIcon(4)}
                      color={setTabColor(4)}
                    />
                    &nbsp;
                    <span class="tabName">
                      Employee <span className="pl-20">Classification</span>
                    </span>
                  </div>
                }
                tabClassName={setTabClass(4)}
                disabled={false}
              >
                <WithdrawalRequestEmployeeClassification
                  // {...formProps}
                  fields={fields}
                  // isEdit={isEdit}
                  // isSave={isSave}
                  // changeInCmpyId={changeInCmpyId}
                  // isCmpy={isCmpy}
                  // history={history}
                  filteredValues={filteredValues}
                  // setResponse={setResponse}
                />
                {/* {isEdit == true ? null : (
                <>
                  <Button
                    className="add-btn mr-4"
                    onClick={tabDates}
                  >
                    Previous
                  </Button>
                  <Button onClick={tabOthers}>Next</Button>
                </>
              )} */}
              </Tab>
              <Tab
                eventKey={5}
                title={
                  <div>
                    <FontAwesomeIcon
                      icon={setTabIcon(5)}
                      color={setTabColor(5)}
                    />
                    &nbsp;
                    <span class="tabName">
                      Other <span className="pl-20">Information</span>
                    </span>
                  </div>
                }
                tabClassName={setTabClass(5)}
                disabled={false}
              >
                <WithdrawalRequestOtherInformation
                  // {...formProps}
                  fields={fields}
                  filteredValues={filteredValues}
                  // isEdit={isEdit}
                  // isSave={isSave}
                />
                {/* {isEdit == true ? null : (
                <>
                  <Button
                    className="add-btn mr-4"
                    onClick={tabEmployee}
                  >
                    Previous
                  </Button>
                  <Button type="submit">Save</Button>
                </>
              )} */}
              </Tab>
            </Tabs>
          </div>
        </SliderPanel>
      </div>
    </LoaderWrapper>
  );
};

const ManageDistributionWithProvider = (props) => {
  return (
    <ManageDistributionProvider>
      <Distribution {...props} />
    </ManageDistributionProvider>
  );
};

export default withAppLayout(ManageDistributionWithProvider);
